export const demo = {
  hero: {
    title: 'Solicita una demo',
    subtitle: 'Descubre cómo nuestras soluciones pueden transformar tu negocio. Completa el formulario y te contactaremos para coordinar tu demo personalizada.'
  },
  form: {
    title: 'Agenda tu demo',
    priority: 'Prioridad de fecha de demo',
    priorityOptions: {
      asap: 'Lo antes posible',
      thisWeek: 'Esta semana',
      nextWeek: 'Próxima semana',
      flexible: 'Flexible'
    },
    success: 'Gracias, te contactaremos para coordinar la demo.'
  }
};
